export default __webpack_public_path__ + "static/media/ed2mit2021mates_00-Introduction-digital-data-training-v03.804c20b4.pdf";